import axios from 'axios';
import { API_URL } from '../config';
import { EmployeeRateo, Rateo } from '../types';
import { AxiosRequestConfig } from 'axios';
interface CustomAxiosRequestConfig extends AxiosRequestConfig {
  permission?: string;
}

//RATEO COMPANY

export const getRateosList = async (token: string) => {
    const response = await axios.get(`${API_URL}/presenze/rateos/`,
     {
        headers: {
          'Authorization': `${token}`,
        },
      });
      return response.data;
  };
  
  export const getRateosCompanyList = async (token: string) => {
    const response = await axios.get(`${API_URL}/presenze/company/rateos/`,
     {
        headers: {
          'Authorization': `${token}`,
        },
      });
      return response.data;
  };
  
  export const addRateoCompany = async (token: string, rateo: number) => {
    const response = await axios.post(`${API_URL}/presenze/company/rateos/`,
      {
        rateo: rateo,
      },
      {
        headers: {
          'Authorization': `${token}`,
        }
      });
    return response.data;
  }
  
  export const deleteRateoCompany = async (token: string, id: number) => {
    const response = await axios.delete(`${API_URL}/presenze/company/rateos/${id}/`,
     {
        headers: {
          'Authorization': `${token}`,
        },
      });
    return response.data;
  };


// RATEO EMPLOYEE

export const createRateoEmployee = async (token: string, id: number, data: any) => {
  const response = await axios.post(`${API_URL}/presenze/employee/${id}/rateos/`,
    data,
    {
      headers: {
        'Authorization': `${token}`,
      }
    });
  return response.data;
}

export const getRateosEmployeeList = async (token: string, id: number, permission: string | null) => {
  const response = await axios.get(`${API_URL}/presenze/employee/${id}/rateos/`, {
    headers: {
      'Authorization': token,
    },
    permission,
  } as CustomAxiosRequestConfig);
  return response.data;
};

export const deleteRateoEmployee = async (token: string, employeeId: number, rateoId: number) => {
  const response = await axios.delete(`${API_URL}/presenze/employee/${employeeId}/rateos/${rateoId}/`,
   {
      headers: {
        'Authorization': `${token}`,
      },
    });
  return response.data;
};

export const updateRateoEmployee = async (token: string, employeeId: number, rateoId: number, updatedRateo: EmployeeRateo) => {
  const response = await axios.patch(`${API_URL}/presenze/employee/${employeeId}/rateos/${rateoId}/`, {...updatedRateo}, 
  {
    headers: {
      'Authorization': token,
    }
  });
  return response.data;
};
